import { createStyles, Theme } from '@material-ui/core/styles';

export const styles = ({
  palette: {
    error: { main },
  },
  custom: { fontSizes },
  spacing: { unit },
}: Theme) =>
  createStyles({
    asterisk: {
      color: main,
    },
    label: {
      display: 'block',
      fontSize: fontSizes.body,
      marginBottom: unit,
      marginLeft: unit / 2,
      transform: 'translate(0, 1.5px) scale(0.75) !important',
      transformOrigin: 'top left !important',
      transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms !important',
      width: '133.33% !important',
    },
    type: {
      display: 'inline-block',
      float: 'left',
      position: 'relative',
      width: 131,
    },
    value: {
      display: 'inline-block',
      marginLeft: -1,
      position: 'relative',
      width: 'calc(100% - 130px)',
    },
  });
